import { amplifyClient } from 'api';
import { getUrlToFetchAndAdd, getUrlToUpdateAndRemove } from 'features/users/endpoints';
import { createApiSlice } from 'helpers/createApiSlice';
import { call } from 'redux-saga/effects';
import { AnyRecord, UserData } from 'types';

/**
 * FETCH
 */

type DataFetch = Array<UserData>;

type PayloadFetch = {
  companyId?: string;
};

export const usersFetch = createApiSlice<DataFetch, PayloadFetch | undefined>({
  name: 'usersFetch',
  *tryGenerator(_, { payload }) {
    const { companyId } = payload || {};

    const { data } = yield call(amplifyClient, {
      method: 'get',
      url: getUrlToFetchAndAdd(companyId),
    });

    return data;
  },
});

/**
 * ADD
 */

type DataAdd = UserData;

type PayloadAdd = {
  data: Record<string, unknown>;
  companyId?: string;
};

export const usersAdd = createApiSlice<DataAdd, PayloadAdd>({
  name: 'usersAdd',
  *tryGenerator(_, { payload: { data, companyId } }) {
    const { data: response } = yield call(amplifyClient, {
      method: 'post',
      url: getUrlToFetchAndAdd(companyId),
      data,
    });

    return response;
  },
});

/**
 * UPDATE
 */

type DataUpdate = UserData;

type Payload = {
  data: AnyRecord;
};

export const usersUpdate = createApiSlice<DataUpdate, Payload>({
  name: 'usersUpdate',
  *tryGenerator(_, { payload: { data } }) {
    const { username, ...remainderData } = data;

    const { data: response } = yield call(amplifyClient, {
      method: 'put',
      url: getUrlToUpdateAndRemove(username),
      data: remainderData,
    });

    return response;
  },
});

/**
 * REMOVE
 */

type PayloadRemove = {
  username: string;
};

export const usersRemove = createApiSlice<unknown, PayloadRemove>({
  name: 'usersRemove',
  *tryGenerator(_, { payload: { username } }) {
    yield call(amplifyClient, {
      method: 'del',
      url: getUrlToUpdateAndRemove(username),
    });

    return null;
  },
});
